import React from "react";

const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return `${String(date.getDate()).padStart(2, "0")}-${String(
    date.getMonth() + 1
  ).padStart(2, "0")}-${date.getFullYear()}`;
};

// Helper to get image src from File or URL
function getImageSrc(fileOrUrl) {
  if (!fileOrUrl) return "";
  if (typeof fileOrUrl === "object" && fileOrUrl instanceof File) {
    return URL.createObjectURL(fileOrUrl);
  }
  return fileOrUrl;
}

const DrivingLicensePreview = ({ data, frontFile, backFile }) => {
  return (
    <div className="space-y-2">
      <p>
        <strong>DL Number:</strong> {data.dlNumber}
      </p>
      <p>
        <strong>Full Name:</strong> {data.fullName}
      </p>
      <p>
        <strong>Date of Birth:</strong> {formatDate(data.dob)}
      </p>
      <p>
        <strong>Date of Issue:</strong> {formatDate(data.doi)}
      </p>
      <p>
        <strong>Date of Expiry:</strong> {formatDate(data.doe)}
      </p>
      <div>
        <p className="font-semibold">DL Front Image:</p>
        <img
          src={getImageSrc(frontFile || data.dlfront)}
          alt="DL Front"
          className="w-full rounded my-2"
          onError={(e) => {
            e.target.style.display = "none";
            e.target.nextSibling.style.display = "block";
          }}
        />
        <div style={{ display: "none" }} className="text-red-500 text-sm">
          Failed to load front image
        </div>
      </div>
      <div>
        <p className="font-semibold">DL Back Image:</p>
        <img
          src={getImageSrc(backFile || data.dlback)}
          alt="DL Back"
          className="w-full rounded my-2"
          onError={(e) => {
            e.target.style.display = "none";
            e.target.nextSibling.style.display = "block";
          }}
        />
        <div style={{ display: "none" }} className="text-red-500 text-sm">
          Failed to load back image
        </div>
      </div>
    </div>
  );
};

export default DrivingLicensePreview;
